import React from 'react';

const Tick = () => <path fill="none" fillRule="evenodd" stroke="#4CCD7A" strokeWidth="2" d="M4 13.239l4.567 4.132L20.492 6" />;

Tick.displayName = 'Tick';

export default Tick;
